import UltMeta, { Meta } from "./UltMeta/index";

class Origin extends UltMeta {
    PC = new Meta(1, "pc 端");
    MINI_APP = new Meta(2, "小程序端");
}
export const ORIGIN = new Origin();

class CertificationType extends UltMeta {
    PERSONAL = new Meta(1, "个人");
    ENTERPRISE = new Meta(2, "组织");
}
export const CERTIFY_TYPE = new CertificationType();

// 后台管理 -- 组织机构认证
export enum AUTH_EMTICATION_STATE_MAP {
    NOT_STATE = -1,
    PENDING = 1,
    ERROR = 2,
    SUCCESS = 3
}

// 个人认证
export enum AUTH_PERSON_STATE_MAP {
    PENDING = 0,
    SUCCESS = 1,
    ERROR = 2
}

// 契约锁认证状态
export enum AUTH_EMTICATION_STATE {
    notState = -1,
    pending = 0,
    success = 1,
    error = 2
}
